import { render, staticRenderFns } from "./deparaSimpleTable.vue?vue&type=template&id=5eb3a3eb"
import script from "./deparaSimpleTable.vue?vue&type=script&lang=js"
export * from "./deparaSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./deparaSimpleTable.vue?vue&type=style&index=0&id=5eb3a3eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports